export const environment = {
  production: false,
  apiUrl: 'https://dev-miranda.megakit.pro/client',
  utaxCloudApiUrl: 'https://utax-cloud.dev-miranda.megakit.pro',
  registrationUrl: 'https://reg.dev-miranda.megakit.pro',
  bypassRestoreGuard: true,
};
